export default function BackToDashboard() {
    const dashboardURL = process.env.REACT_APP_DASHBOARD_LINK || 'https://start.ai-pro.org/my-account';
    const referrer = document.referrer;
    const invalid_referrer = referrer === '' || referrer === window.location.href;
  
    if (invalid_referrer || window.self !== window.top) {
      return;
    }
  
    return (
      <div className='back-to-dashboard-btn flex flex-shrink-0 px-2 py-1 pr-5 '
      onClick={
        () => {
          window.location.href = dashboardURL;
        }
      }>
        <span className='pt-[5px] mr-2'>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3078 12.0385C11.5016 12.0385 11.6875 11.9615 11.8245 11.8244C11.9616 11.6874 12.0386 11.5015 12.0386 11.3077L12.0386 2.69231C12.0386 2.49849 11.9616 2.31262 11.8245 2.17558C11.6875 2.03853 11.5016 1.96154 11.3078 1.96154L8.84627 1.96154C8.57013 1.96154 8.34627 1.73768 8.34627 1.46154C8.34627 1.18539 8.57013 0.961537 8.84627 0.961537L11.3078 0.961537C11.7668 0.961537 12.2071 1.14389 12.5316 1.46847C12.8562 1.79305 13.0386 2.23328 13.0386 2.69231L13.0386 11.3077C13.0386 11.7667 12.8562 12.2069 12.5316 12.5315C12.2071 12.8561 11.7668 13.0385 11.3078 13.0385L8.84627 13.0385C8.57012 13.0385 8.34627 12.8146 8.34627 12.5385C8.34627 12.2623 8.57012 12.0385 8.84627 12.0385L11.3078 12.0385ZM4.89453 10.4302C4.69927 10.6254 4.38269 10.6254 4.18742 10.4302L1.14043 7.38318C1.03114 7.29146 0.961652 7.15384 0.961652 7C0.961652 6.84801 1.02947 6.71186 1.13649 6.62016L4.18743 3.56922C4.38269 3.37396 4.69927 3.37396 4.89453 3.56922C5.08979 3.76448 5.08979 4.08107 4.89453 4.27633L2.67086 6.5L8.84627 6.5C9.12241 6.5 9.34627 6.72386 9.34627 7C9.34627 7.27614 9.12241 7.5 8.84627 7.5L2.67146 7.5L4.89453 9.72307C5.08979 9.91833 5.08979 10.2349 4.89453 10.4302Z" fill="black"/>
          </svg>
        </span>
        Back to Dashboard
      </div>
    );
  }
  